import { render, staticRenderFns } from "./ArticleExpansionPanels.vue?vue&type=template&id=1e2d6868&scoped=true"
import script from "./ArticleExpansionPanels.vue?vue&type=script&lang=js"
export * from "./ArticleExpansionPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2d6868",
  null
  
)

export default component.exports